import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProfileDto, ProfileState } from 'src/app/api/wallet-api.generated';
import { ProfilesService } from 'src/app/profiles/profiles.service/profiles.service';

@Component({
  selector: 'app-profile-card',
  templateUrl: './profile-card.component.html',
  styleUrls: ['./profile-card.component.scss']
})
export class ProfileCardComponent {
  @Input() profile: ProfileDto;
  @Input() canDelete = false;
  @Output() profileSelected: EventEmitter<ProfileDto>;
  @Output() profileDelete: EventEmitter<ProfileDto>;
  profileStates = ProfileState;

  constructor(public profilesService: ProfilesService,) {
    this.profileSelected = new EventEmitter();
    this.profileDelete = new EventEmitter();
  }

  onProfileClick(profile: ProfileDto) {
    this.profileSelected.emit(profile);
  }

  onDeleteClick(event) {
    event.stopPropagation();
    event.preventDefault();
    this.profileDelete.emit(this.profile);
  }

}
